import React from 'react'
import { Launchpad } from './Launchpad/page'

export function LaunchpadWithContext() {
  return <Launchpad />
}
